<template lang="pug">
#reservation-settings
  .box
    .box-body
      b-tabs(v-model="tabIndex")
        // room inout schedules
        b-tab.tab(v-if="_showReservationSettingTab")
          template(#title)
            .icon-offline.mr-2(title="訪問面会の基本設定")
            span 訪問面会の基本設定
          ReservationSettingTab
        // export report tab
        b-tab.tab(v-if="_showOnlineReservationSettingTab")
          template(#title)
            .icon-online.mr-2(title="オンライン面会の基本設定")
            span オンライン面会の基本設定
          OnlineReservationSettingTab
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import ReservationSettingTab from "@/pc/containers/reservations/ReservationSettingTab.vue";
import OnlineReservationSettingTab from "@/pc/containers/reservations/OnlineReservationSettingTab.vue";

/**
 * ### 面会予約設定画面コンポーネント
 */
@Component({
  components: {
    ReservationSettingTab,
    OnlineReservationSettingTab
  }
})
export default class ReservationSettings extends Vue {
  /** タブインデックス(0始まり) */
  tabIndex: number = 0;

  get _showReservationSettingTab(): boolean {
    const permittedReservation: boolean = userStore.facility.permittedFunctions.reservation;
    const useReservationSettings: boolean = userStore.user.permissions.reservationsFunction.useReservationSettings;

    if (permittedReservation && useReservationSettings) {
      return true;
    } else {
      return false;
    }
  }

  get _showOnlineReservationSettingTab(): boolean {
    const permittedOnlineReservation: boolean = userStore.facility.permittedFunctions.onlineReservation;
    const useOnlineReservationSettings: boolean = userStore.user.permissions.reservationsFunction.useOnlineReservationSettings;

    if (permittedOnlineReservation && useOnlineReservationSettings) {
      return true;
    } else {
      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_mixin.scss";
@import "../../../styles/pc/_colors.scss";

#reservation-settings {
  max-width: 820px;
  margin-left: auto;
  margin-right: auto;

  .icon-offline {
    @include svg-icon("../../../assets/reservation/offline.svg", $font-base-color, 24px, 24px);
  }
  .icon-online {
    @include svg-icon("../../../assets/reservation/online.svg", $font-base-color, 24px, 24px);
  }
}
</style>
